import narLogo from "@/assets/nar-logo.svg";
import nslbaLogo from "@/assets/nslba.png";
import gonzalezLegalLogo from "@/assets/gonzalez-legal.png";
import realtorMlsLogo from "@/assets/realtor-mls-logo.png";
import valtaGroupLogo from "@/assets/valta-img.png";
import mlpLogo from "@/assets/mlp.png";
import { useFadeIn } from "@/hooks/useFadeIn";

const logos = [
  {
    src: narLogo,
    alt: "National Association of Realtors",
    hasDarkBackground: false,
  },
  {
    src: realtorMlsLogo,
    alt: "Realtor MLS",
    hasDarkBackground: false,
  },
  {
    src: nslbaLogo,
    alt: "North Shore Latino Business Association",
    hasDarkBackground: false,
  },
  {
    src: gonzalezLegalLogo,
    alt: "Gonzalez Legal P.C.",
    hasDarkBackground: false,
  },
  {
    src: valtaGroupLogo,
    alt: "The Valta Group LLC",
    hasDarkBackground: false,
  },
  {
    src: mlpLogo,
    alt: "MLP",
    hasDarkBackground: false,
  },
];

const TrustStrip = () => {
  const { ref, visible } = useFadeIn();

  return (
    <section
      ref={ref}
      className={`mt-8 border-b border-neutral-200 bg-[#f8f6f2] py-6 transition-all duration-700 md:mt-10 md:py-8 ${
        visible ? "translate-y-0 opacity-100" : "translate-y-4 opacity-0"
      }`}
    >
      <div className="mx-auto max-w-wide px-5 md:px-12">
        <div className="mb-4 text-center md:mb-5">
          <p className="font-body text-[10px] uppercase tracking-[0.3em] text-accent mb-2">
            Trusted Partners and Associations
          </p>
          <p className="text-muted-foreground text-sm md:text-base">
            Proudly affiliated with leading real estate and local organizations
          </p>
        </div>

        <div className="relative">
          <div
            className="pointer-events-none absolute inset-y-0 left-0 z-10 w-8 bg-gradient-to-r from-[#f8f6f2] to-transparent md:hidden"
            aria-hidden="true"
          />
          <div
            className="pointer-events-none absolute inset-y-0 right-0 z-10 w-8 bg-gradient-to-l from-[#f8f6f2] to-transparent md:hidden"
            aria-hidden="true"
          />

          <div className="overflow-hidden md:hidden">
            <div className="animate-marquee flex min-w-max items-center gap-6 whitespace-nowrap pr-6 hover:[animation-play-state:paused]">
              {[...logos, ...logos].map((logo, index) => (
                <div
                  key={`${logo.alt}-${index}`}
                  className="flex h-[72px] min-w-[132px] flex-shrink-0 items-center justify-center px-2"
                  aria-hidden={index >= logos.length}
                >
                  <img
                    src={logo.src}
                    alt={index < logos.length ? logo.alt : ""}
                    className="max-h-[46px] w-auto max-w-full object-contain opacity-80 transition-all duration-300 hover:opacity-100"
                    loading="lazy"
                    decoding="async"
                    width={180}
                    height={60}
                  />
                </div>
              ))}
            </div>
          </div>

          <div className="hidden md:flex md:w-full md:min-w-0 md:items-center md:justify-between md:gap-8 lg:gap-10">
            {logos.map((logo) => (
              <div
                key={logo.alt}
                className="flex h-[84px] min-w-0 flex-1 items-center justify-center px-3 lg:px-4"
              >
                <img
                  src={logo.src}
                  alt={logo.alt}
                  className="max-h-[54px] w-auto max-w-full object-contain opacity-80 transition-all duration-300 hover:opacity-100"
                  loading="lazy"
                  decoding="async"
                  width={200}
                  height={64}
                />
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default TrustStrip;
